import { render, staticRenderFns } from "./Audit.vue?vue&type=template&id=66227574&"
import script from "./Audit.vue?vue&type=script&lang=js&"
export * from "./Audit.vue?vue&type=script&lang=js&"
import style0 from "./Audit.vue?vue&type=style&index=0&id=66227574&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports